import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {getUserId, loadCartFromLocalStorage, saveCartToLocalStorage} from '../localStorageService';
import {CartState, ItemType, OrderData} from "../../entity/index.entity";
import {fetchContact} from "./ContactSlice";
import {API_URL} from "../../constants";
import {checkResponse} from "../../utils";

const userId = getUserId();
const initialState = {
    cart: loadCartFromLocalStorage(userId) as ItemType[],
    exist: null,
    discount: null
} as CartState;

export const fetchPromo = createAsyncThunk(
    'cart/fetchPromo',
    async (promo: string) => {
        const res = await fetch(`${API_URL}/check-promocode/${promo}`);
        const data = await checkResponse(res);
        return data;
    }
);

export const fetchCreateOrder = createAsyncThunk(
    'cart/fetchCreateOrder',
    async (orderData: OrderData, {rejectWithValue}) => {
        try {
            const res = await fetch(`${API_URL}/shop/create-order/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(orderData),
            });
            return await checkResponse(res);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);


const CartSlice = createSlice({
    name: 'cartSlice',
    initialState,
    reducers: {
        addToCart(state, action) {

            const {item, size} = action.payload;
            const existingItem = state.cart.find((cartItem) => cartItem.id === item.id && cartItem.size === size);

            if (existingItem) {
                existingItem.quantity = (existingItem.quantity || 1) + 1;
            } else {
                state.cart.push({...item, size, quantity: 1});
            }

            saveCartToLocalStorage(userId, state.cart);
        },
        removeFromCart(state, action) {
            const {itemId, size} = action.payload;
            state.cart = state.cart.filter((item) => !(item.id === itemId && item.size === size));
            saveCartToLocalStorage(userId, state.cart);
        },
        updateQuantity(state, action) {
            const {itemId, size, quantity} = action.payload;
            const item = state.cart.find((cartItem) => cartItem.id === itemId && cartItem.size === size);

            if (item) {
                item.quantity = quantity;

                if (item.quantity && item.quantity <= 0) {
                    state.cart = state.cart.filter((cartItem) => !(cartItem.id === itemId && cartItem.size === size));
                }
            }

            saveCartToLocalStorage(userId, state.cart);
        },
        clearCart(state) {
            state.cart = [];
            saveCartToLocalStorage(userId, state.cart);
        },
        resetPromo(state) {
            state.exist = null;
            state.discount = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPromo.fulfilled, (state, action) => {
                state.exist = action.payload.exists;
                state.discount = action.payload.discount;
            })
    },
});

export const {addToCart, removeFromCart, updateQuantity, resetPromo, clearCart} = CartSlice.actions;
export default CartSlice.reducer;